const UrlInput = ({ url, setUrl, fetchBlog }) => {
  return (
    <div className="bg-white border rounded-xl p-6 mb-6">
      <div className="flex gap-3">
        <input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="Blog URL"
          className="flex-1 border rounded-lg px-3 py-2"
        />

        <button
          onClick={fetchBlog}
          className="bg-blue-500 text-white px-6 rounded-lg"
        >
          Fetch
        </button>
      </div>
    </div>
  );
};

export default UrlInput;
